import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';


if (environment.production) {
  enableProdMode();
  /*  To Disable console logs in production environment   */
  if (window) {
    window.console.log =
      window.console.warn =
      window.console.info =
        function () {
          // Don't log anything.
        };
  }

  // sentry working for production
  Sentry.init({
    dsn: environment.DSN_FOR_SENTRY,
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
  })
}
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
